import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vant/lib/index.css";
import {
    Loading,
    ImagePreview,
    Lazyload,
    Uploader,
    Swipe,
    SwipeItem,
    Button,
    Circle,
    Image as VanImage,
    Toast,
    Popup,
    Checkbox,
    CheckboxGroup,
    Field,
    Switch,
    List,
    Tab, 
    Tabs,
    Skeleton
} from "vant";
import { checkLoginApi } from "@/store/getData";
import '@vant/touch-emulator';

Vue.use(Loading);
Vue.use(ImagePreview);
Vue.use(Lazyload);
Vue.use(Uploader);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Circle);
Vue.use(VanImage)
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup)
Vue.use(Field);
Vue.use(Switch);
Vue.use(List);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Skeleton);


Vue.config.productionTip = false;
// sessionStorage.setItem("client", "mlyy");
sessionStorage.setItem('firstPage', location.href.split('#')[0])

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

// if (process.env.NODE_ENV === "development") {
//     new Vue({
//         router,
//         store,
//         render: h => h(App)
//     }).$mount("#app");
// } else {
//     checkLoginApi({
//         client: sessionStorage.getItem("client"),
//         url: location.href
//     })
//         .then(res => {
//             new Vue({
//                 router,
//                 store,
//                 render: h => h(App)
//             }).$mount("#app");
//         })
//         .catch(result => {
//             if (result.code == 401) {
//                 location.href = result.url;
//             }
//         });
// }
